// @flow
import * as React from 'react';
import classNames from 'classnames';

export type HeadlineProps = {
  level: number,
  size?: number | 'teaser' | 'kicker',
  id?: string,
  kicker?: string,
  inverted?: boolean,
  kickerAttr?: { [string]: string },
  children: React$Node,
  text?: string,
  headlineClass?: string,
};

const Headline = (props: HeadlineProps): React$Element<string> => {
  const {
    level, kicker, kickerAttr = {}, children, size, id, inverted, headlineClass,
  } = props;

  const { className, ...kickerAttrRest } = kickerAttr;

  const Tag = `h${Math.min(Math.max(level, 1), 6)}`;
  const headlineSize = size || level;
  const headlineClasses = classNames({
    headline: true,
    [`headline--${headlineSize}`]: headlineSize,
    'headline--inverted': inverted,
    [(headlineClass: any)]: headlineClass,
  });

  const kickerClasses = classNames({
    headline__kicker: true,
    [className]: className,
  });

  return (
    <Tag className={headlineClasses} id={id}>
      {kicker && (
        <span {...kickerAttrRest} className={kickerClasses}>
          {kicker}
          <span className="u-hidden-visually">: </span>
        </span>
      )}
      {children}
    </Tag>
  );
};

export default Headline;
